import { TYPEFORM_LINK } from 'sly/b2b/constants';
import { eventNames, useEvents } from 'sly/services/events';

export default function PartnerBusinessHeader() {
  const { events } = useEvents();
  const handleClick = () => {
    if (location)
      events.track(eventNames.ButtonClicked, {
        text: 'Schedule call in header',
        location: 'B2B partner page',
      });
    window.open(TYPEFORM_LINK, '_blank');
  };
  return (
    <header className='provider-gradiant m-4 flex flex-col items-center rounded-xl py-12 px-6 md:p-0'>
      <div className='flex flex-col items-center gap-4 md:max-w-5xl md:p-20'>
        <div className='flex flex-col items-center gap-4 md:w-[670px]'>
          <div className='flex self-stretch sm:justify-center '>
            <section className='font-t-xxl text-center sm:w-[600px]'>
              Transform your business with Seniorly
            </section>
          </div>
          <section className='font-b-l text-center'>
            If your business supports older adults, we&apos;ve got solutions to
            help you improve service delivery and grow the bottom line. Ignite
            existing audiences, discover new ones, and build meaningful revenue
            streams with our senior housing programs.
          </section>
          <hr />
        </div>
        <button
          className='provider-cta self-stretch sm:self-auto'
          onClick={handleClick}
        >
          <p className='font-t-m-azo-xs text-white'>Schedule a call</p>
        </button>
      </div>
    </header>
  );
}
